require("./src/css/index.css");

const React = require("react");
const { SEOProvider } = require("./src/context/SEOContext");

exports.wrapRootElement = ({ element }) => {
  return <SEOProvider>{element}</SEOProvider>;
};
